import CompanyProfileDto from '@/models/Companies/CompanyProfileDto';
import LocationProfileDto from '@/models/Locations/LocationProfileDto';
import BranchDto from '@/models/Branches/BranchDto';
import DeskDto from '@/models/Desks/DeskDto';
import AgencyUserDto from '@/models/AgencyUsers/AgencyUserDto';
import PositionDto from '@/models/Positions/PositionDto';
import JobStatus from '@/models//Jobs/JobStatus';
import WorkerProfileDto from '@/models/Workers/WorkerProfileDto';
import QualificationDto from '@/models//Qualifications/QualificationDto';
import SkillDto from '@/models/Skills/SkillDto';
import DistanceViewModel from '@/models/Shared/DistanceViewModel';
import WorkerDto from '@/models/Workers/WorkerDto';
import JobProfileDto from './JobProfileDto';

export default class JobSearchViewModel {
    
    selectedBranch: BranchDto;
    selectedDesk: DeskDto;
    companies: CompanyProfileDto[] = [];
    selectedCompany: CompanyProfileDto;
    locations: LocationProfileDto[] = [];
    selectedLocation: LocationProfileDto;
    selectedOwner: AgencyUserDto = new AgencyUserDto;
    workers: WorkerProfileDto[] = [];
    selectedWorker: WorkerProfileDto;
    annualSalary: number = null;
    selectedPositions: PositionDto[] = [];
    includeSecondaryPositions = false;
    selectedSkills: SkillDto[] = [];
    selectedQualifications: QualificationDto[] = [];
    selectedStatus: JobStatus = JobStatus.Open;
    selectedDistance: DistanceViewModel = new DistanceViewModel(20, "20");
    selectedJobs: JobProfileDto[] = [];
}